export default __webpack_public_path__ + "components/03-features/brand/footer-menus/footer-menus.html.twig";